export interface Category {
  id: string;
  name: string;
  slug: string;
  desc: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: "business",
    name: "商业起底",
    slug: "business",
    desc: "拆解企业的扩张路径、财务结构与关键决策，看清一次商业动作背后的真实动机。",
    icon: "ri-building-2-line",
    count: 428,
  },
  {
    id: "industry",
    name: "行业内幕",
    slug: "industry",
    desc: "从规则、定价到供应链，梳理行业里那些不会被写进公开材料的隐形逻辑。",
    icon: "ri-node-tree",
    count: 512,
  },
  {
    id: "opinion",
    name: "舆情深挖",
    slug: "opinion",
    desc: "追踪一条信息如何被放大、扭转与消费，还原公共讨论真实的发酵路径。",
    icon: "ri-chat-history-line",
    count: 346,
  },
];